import fetch from "isomorphic-fetch";
import { message, setIsFetching } from "../../../actions";
import Configuration from "../../../config.js";
import ReactGA from "react-ga";

/**
 * Konstanten
 */
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_QUESTIONNAIRE_DOCUMENTS = "SET_QUESTIONNAIRE_DOCUMENTS";

/**
 * Setter
 */
export function setDocuments( json )
{
	return {
		type: SET_DOCUMENTS,
		json
	};
}

export function setQuestionnaireDocuments( json )
{
	return {
		type: SET_QUESTIONNAIRE_DOCUMENTS,
		json
	};
}

/**
 * Zeigt alle Dokumente an.
 * @template Vorlage wird derzeit nicht verwendet
 *
 */
export function getDocuments()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Document",
				action: "Alle Dokumente laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/documents?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									// State aktualisieren
									dispatch( setDocuments( json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getDocuments(...)

/**
 * Läd die Dokumente zum gewählten Fragebogen
 *
 * @param id {number}
 */
export function getQuestionnaireDocuments( id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Document",
				action: "Dokumentenliste laden"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${id}/documents?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									dispatch( setQuestionnaireDocuments( json ) );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getQuestionnaireDocuments(...)

/**
 * Lädt das gewählte Dokument herunter
 *
 * @param a_id {number} Dokumenten-Id
 * @param a_filename {string} Dokumenten-Name
 */
export function downloadDocument( a_id, a_filename )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Document",
				action: "Dokument laden",
				label: `/admin/documents/${a_id}`
			} );
		}
		
		const { jwt } = { ...getState() };
		let headers = jwt !== null ? { "JWT": jwt } : {};
		return fetch(
			`${Configuration.apiUrl}/admin/documents/${a_id}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response
							.text()
							.then( data =>
							{
								const encodedData = atob( data );
								
								// Blob erzeugen
								const mx = encodedData.length;
								const uiArr = new Uint8Array( mx );
								
								let i = 0;
								for ( i; i < mx; ++i )
								{
									uiArr[ i ] = encodedData.charCodeAt( i );
								}
								
								const blob = new Blob( [ uiArr ], { type: response.headers.get( "Content-Type" ) } );
								
								// IE
								if ( window.navigator && window.navigator.msSaveOrOpenBlob )
								{
									window.navigator.msSaveOrOpenBlob( blob, a_filename );
									dispatch( setIsFetching( false ) );
								}
								else
								{
									// Datei zum download anzeigen
									const url = URL.createObjectURL( blob );
									let a = document.createElement( "a" );
									document.body.appendChild( a );
									a.style = "display: none";
									a.href = url;
									a.download = a_filename;
									a.click();
									
									dispatch( setIsFetching( false ) );
								}
							} );
					}
					else
					{
						response.json()
							.then( json =>
								{
									dispatch( message( json.error, "error" ) );
									dispatch( setIsFetching( false ) );
								}
							);
					}
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function downloadDocument(...)

/**
 * Api-Anfrage: Dokument zum Fragebogen hinzufügen
 *
 * @param data {Object}
 * @param questionnaire_id {Number}
 */
export function uploadQuestionnaireDocument( data, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Document",
				action: "Dokument speichern"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		// headers[ "content-type" ] = "application/json";
		
		let formData = new FormData();
		formData.append( "title", data.title );
		formData.append( "file", data.file );
		formData.append( "filename", data.filename );
		formData.append( "filesize", data.filesize );
		formData.append( "mime_type", data.mime_type );
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/documents`,
			{
				credentials: "include",
				method: "POST",
				body: formData,
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Dokument erfolgreich hinzugefügt.", "info", 5000 ) );
						dispatch( getQuestionnaireDocuments( questionnaire_id ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( setIsFetching( false ) );
					
					// Fehlerbehandlung einfügen..
				}
			);
	};
	
} // function uploadQuestionnaireDocument(...)

/**
 * Api-Anfrage: Dokument löschen
 *
 * @param id {number}
 * @param questionnaire_id {number}
 */
export function deleteDocument( id, questionnaire_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Document",
				action: "Dokument löschen"
			} );
		}
		
		const jwt = getState().jwt;
		let headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${questionnaire_id}/documents/${id}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Dokument aus dem State löschen
						dispatch( getQuestionnaireDocuments( questionnaire_id ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Dokument erfolgreich gelöscht.", "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteDocument(...)
